import { ExternalLink, LibraryBig, PlayCircle } from 'lucide-react';
import { resourceLinks } from '../data';
import type { ResourceKind } from '../types';

const featuredIds = [
  'cng-river',
  'nfga-wetland',
  'ibcas-grassland',
  'hulun-birds',
  'csf-insects',
  'kepuchina-swallow',
  'cctv-morigele'
];

const kindLabel: Record<ResourceKind, string> = {
  article: '科普文章',
  video: '视频',
  database: '数据库',
  policy: '报告/法规',
  gallery: '图集'
};

export function ResourceShelf() {
  const featuredLinks = resourceLinks.filter((link) => featuredIds.includes(link.id));

  return (
    <section className="resource-shelf chapter-library" aria-label="Chapter resource library">
      <div className="panel-heading">
        <LibraryBig aria-hidden="true" />
        <div>
          <h2>书末精选资料</h2>
          <p>这些不是随手附上的链接，而是本章正文使用到的核心资料。想继续了解时，从这里开始。</p>
        </div>
      </div>

      <div className="resource-grid">
        {featuredLinks.map((link) => (
          <a className="resource-card" href={link.url} key={link.id} rel="noreferrer" target="_blank">
            <span className="resource-meta">
              <b>{kindLabel[link.kind]}</b>
              <small>{link.source}</small>
            </span>
            <strong>
              {link.kind === 'video' && <PlayCircle aria-hidden="true" />}
              {link.title}
            </strong>
            <p>{link.summary}</p>
            <span className="resource-footer">
              {link.audience}
              <ExternalLink aria-hidden="true" />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}
